import React from 'react';
import { TextInput, DropdownSelector, CheckBox } from 'hyperdb-utils';
import DominoFields from './DominoFields';
import SPRABFields from './SPRABFields';
import RUFields from './RUFields';

const Form = ({ objectData, onChange, onClickCheckbox, onChangeSettings }) => {
  const renderSettingsComponent = () => {
    let SettingsComponent;
    switch (objectData.protocol) {
    case 'SPRAB':
      SettingsComponent = SPRABFields;
      break;
    case 'RentalsUnited':
      SettingsComponent = RUFields;
      break;
    case 'Domino':
      SettingsComponent = DominoFields;
    }
    return SettingsComponent
      ? <SettingsComponent
          type={ objectData.type }
          checkboxesToDisplay={ checkboxesToDisplay(objectData.type, objectData.protocol) }
          settings={ objectData.settings || {} }
          onChange={ onChangeSettings } />
      : null;
  };
  const onChangeProtocolOrType = (attributeName, field) => {
    const type = attributeName === 'type' ? field.value : objectData.type;
    const protocol = attributeName === 'protocol' ? field.value : objectData.protocol;
    const checkboxes = type === 'input'
      ? ['receive_property_details', 'receive_prices', 'receive_conditions', 'receive_availability', 'send_inquiries', 'send_reservations']
      : ['send_property_details', 'send_prices', 'send_conditions', 'send_availability', 'receive_inquiries', 'receive_reservations'];
    const checkedBoxes = checkboxesToDisplay(type, protocol);
    const updatedSettings = { ...objectData.settings || {} };
    checkboxes.forEach(checkbox => {
      const checked = checkedBoxes.includes(checkbox);
      updatedSettings[checkbox] = checked;
    });
    onChange(attributeName, field);
    onChange('settings', { value: updatedSettings });
  };
  return (
    <fieldset>
      {
        objectData.id
          ? <CheckBox
              label="Enabled"
              name="enabled"
              disabled={ !canEnable(objectData) }
              checked={ objectData.enabled }
              onChange={ onClickCheckbox.bind(null, 'enabled') }
            />
          : null
      }
      <TextInput
        label="Name"
        name="name"
        value={ objectData.name }
        onChange={ onChange.bind(null, 'name') }
      />
      <DropdownSelector
        label="Type"
        name="type"
        value={ objectData.type }
        options={ [{ name: 'Input', value: 'input' }, { name: 'Output', value: 'output' }] }
        onChange={ onChangeProtocolOrType.bind(null, 'type') }
        disabled={ !!objectData.id }
      />
      {
        objectData.type
          ? <DropdownSelector
              label="Protocol"
              name="protocol"
              value={ objectData.protocol }
              options={ ['Domino', 'SPRAB', 'RentalsUnited'].map(opt => ({ name: opt, value: opt })) }
              onChange={ onChangeProtocolOrType.bind(null, 'protocol') }
              disabled={ !!objectData.id }
            />
          : null
      }
      {
        objectData.type && objectData.protocol
          ? <fieldset>
              <legend>Settings</legend>
              { renderSettingsComponent() }
            </fieldset>
          : null
      }
    </fieldset>
  );
};

function canEnable(objectData) {
  switch (objectData.protocol) {
  case 'RentalsUnited':
    return objectData.settings && objectData.settings.owner_remote_id;
  case 'SPRAB':
    return true;
  case 'Domino':
    return true;
  default:
    return false;
  }
}

function checkboxesToDisplay(type, protocol) {
  if (type === 'input') {
    if (protocol === 'Domino') return ['receive_property_details', 'receive_prices', 'receive_conditions', 'receive_availability', 'send_inquiries', 'send_reservations'];
    if (protocol === 'SPRAB') return ['receive_prices', 'receive_conditions', 'receive_availability', 'send_reservations'];
    if (protocol === 'RentalsUnited') return ['receive_property_details', 'receive_prices', 'receive_conditions', 'receive_availability', 'send_reservations'];
  }
  if (type === 'output') {
    if (protocol === 'Domino') return ['send_property_details', 'send_prices', 'send_conditions', 'send_availability', 'receive_inquiries', 'receive_reservations'];
    if (protocol === 'SPRAB') return ['send_prices', 'send_conditions', 'send_availability', 'receive_reservations'];
    if (protocol === 'RentalsUnited') return ['send_property_details', 'send_prices', 'send_conditions', 'send_availability', 'receive_reservations'];
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/channel/components/Form.jsx